<template>
  <div class="w-100">
    Appointment UPDATE SMS for
    <appointment-object :appointment-number="appointmentNumber()" />

    sent to tech
    <user-object
      :entity-id="appointmentTechnicianId()"
      :name="appointmentTechnicianName()"
      :open-new="true"
      :tooltip="appointmentTechnicianProfile()"
    />

    <message-object :tooltip="messageContent()" />
  </div>
</template>

<script type="text/babel">
import BaseComponent from "./BaseComponent.vue";

export default {
  extends: BaseComponent,
};
</script>
